import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BillingManagementService } from '../../../service/billing-management.service';
import { LanguageManagementService } from '../../../service/language-management.service';
import { BilledProduct, KeyValues10, KeyValues20, KeyValueSet, KeyValueSets, LocalService, Status, TriggeredEvent } from '../../../service/local.service';

@Component({
  selector: 'app-return-products',
  templateUrl: './return-products.component.html',
  styleUrls: ['./return-products.component.scss']
})
export class ReturnProductsComponent implements OnInit {
  lstSectionConfigKeys: string[] = ["return_products"]; isShowDummyHeight = false;
  isViewMode = false; products: BilledProduct[]; billingId = ''; source; intractionType = 1; maxBodyHeight = 0;
  productsLocal: KeyValues20[];
  constructor(public localService: LocalService, private cdr: ChangeDetectorRef, private activeModal: NgbActiveModal, private languageManagementService: LanguageManagementService, private billingManagementService: BillingManagementService) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.onLoad();
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetMaxModalBodyHeight();
    this.cdr.detectChanges();
  }

  onLoad() {
    if (!this.isViewMode) {
      this.productsLocal = [];
      this.products.forEach(x => {
        this.productsLocal.push({
          isSelected: x.details.isSelected,
          key: x.productId,
          v1: x.details.v1,
          v2: x.details.v2,
          v3: x.details.v3,
          v4: x.details.v4,
          v5: x.details.v5,
          v6: x.details.v6,
          v7: x.details.v7,
          v8: x.details.v8,
          v9: x.details.v9,
          v10: x.details.v10,
          v11: x.details.v11,
          v12: x.details.v12,
          v13: x.details.v13,
          v14: x.details.v14,
          v15: x.details.v15,
          v16: x.details.v16,
          v17: x.details.v17,
          v18: x.details.v19,
          v19: x.details.v19,
          v20: x.details.v20
        } as KeyValues20);
      });
      this.productsLocal.forEach(x => {
        x.v7 = '1';
      });
    }
    this.billingManagementService.getReturnInitialization(this.isViewMode ? this.billingId : '').subscribe(result => {
      this.source = result;
    });
  }

  onPopupClose() {
    this.activeModal.close({ event: TriggeredEvent.Close });
  }

  onPopupSave() {
    let data: KeyValueSets = { key: this.billingId, value: [] as KeyValueSet[] } as KeyValueSets;
    this.productsLocal.forEach(x => {
      data.value.push({ key: x.key, value: x.v7, s_value: x.v15 && x.v15.length > 2 ? x.v15 : undefined } as KeyValueSet);
    });
    this.billingManagementService.returnProducts(data).subscribe(result => {
      if (result.status == Status.Success) {
        this.activeModal.close({ event: TriggeredEvent.Ok });
      }
    });
  }

  getMeasurmentType(id) {
    const item = this.source.measurementTypes.find(x => x.key == id);
    return item ? item.value : 'N/A';
  }

  getReturnReason(id) {
    const item = this.source.returnReasons.find(x => x.key == id);
    return item ? item.value : 'N/A';
  }

  getTotalAmount(items = null) {
    let sum = 0;
    if (this.isViewMode) {
      items.map(x => parseFloat(x.v1) * parseFloat(x.v4)).forEach(x => {
        sum = sum + x;
      });
    } else {
      this.productsLocal.map(x => parseFloat(x.v1) * parseFloat(x.v4)).forEach(x => {
        sum = sum + x;
      });
    }
    return sum;
  }

  onRemoveProduct(id, batchId: string) {
    this.productsLocal = this.productsLocal.filter(x => !(x.key == id && x.v15 == batchId));
  }

  showHideDummyHeight(isShow: boolean) {
    this.isShowDummyHeight = isShow;
  }
}
